import ContactForm from "../components/ContactForm";
import SmallCard from "../components/SmallCard";
import ContactFormPic from "../assets/ContactFormPic/Image 654.png";
import logo from "../assets/titlelogo.png";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";
import { FaWhatsapp, FaHeadset, FaEnvelope} from "react-icons/fa";

const Contact = () => {
  return (
    <>
       {/* Background Images */}
       <div className="-z-10 absolute h-full opacity-4 top-0 translate-x-[-50]">
        <img src={logo} alt="bg" className="h-full max-h-40 w-auto object-contain" />
      </div>

      <div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[50px] ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className=" -z-10 absolute h-full opacity-50 left-0 translate-y-[700px]  md:translate-y-[0px]  ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
      {/* Contact Form and Image Section */}
      <div className="flex flex-col md:flex-row md:max-w-7xl mx-auto gap-6 p-4">
        {/* Contact Form takes up more space */}
        <div className="md:w-1/2 w-full">
          <ContactForm />
        </div>

        {/* Image takes up less space */}
        <div className="md:w-1/2 w-full flex justify-center items-center">
          <img
            src={ContactFormPic}
            className="hidden md:block max-w-full max-h-[800px] object-contain rounded-lg shadow-lg"
            alt="Contact"
          />
        </div>
      </div>

      {/* Contact Cards Section */}
        <div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[700px]">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
  </div>
      <div className="bg-[#102742] text-white py-36 px-4 md:px-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">
            We'd love to <span className="text-[#19BFB7]">hear</span> from you
          </h1>
          <p className="text-gray-400">
            Our friendly team is always here to chat.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Sales Card */}
          <div className="bg-[#0D2A4A] p-6 rounded-lg shadow-lg flex flex-col items-start gap-4 hover:scale-105 transition-transform duration-300">
            <div className="bg-[#16C79A] p-3 rounded-md">
              <FaWhatsapp className="text-white text-2xl" />
            </div>
            <h3 className="text-xl font-semibold">Sales</h3>
            <p className="text-gray-400">Speak to our friendly team.</p>
            <a
              href="mailto:sales@aiaura.co.uk"
              className="text-[#16C79A] hover:underline"
            >
              sales@aiaura.co.uk
            </a>
          </div>

          {/* Tech Support Card */}
          <div className="bg-[#0D2A4A] p-6 rounded-lg shadow-lg flex flex-col items-start gap-4 hover:scale-105 transition-transform duration-300">
            <div className="bg-[#16C79A] p-3 rounded-md">
              <FaHeadset className="text-white text-2xl" />
            </div>
            <h3 className="text-xl font-semibold">Tech Support</h3>
            <p className="text-gray-400">We're here to help.</p>
            <a
              href="mailto:support@aiaura.co.uk"
              className="text-[#16C79A] hover:underline"
            >
              support@aiaura.co.uk
            </a>
          </div>

          {/* General Enquiries Card */}
          <div className="bg-[#0D2A4A] p-6 rounded-lg shadow-lg flex flex-col items-start gap-4 hover:scale-105 transition-transform duration-300">
            <div className="bg-[#16C79A] p-3 rounded-md">
              <FaEnvelope className="text-white text-2xl" />
            </div>
            <h3 className="text-xl font-semibold">General Enquiries</h3>
            <p className="text-gray-400">Ask away your queries.</p>
            <a
              href="mailto:admin@aiaura.co.uk"
              className="text-[#16C79A] hover:underline"
            >
              admin@aiaura.co.uk
            </a>
          </div>
        </div>
      </div>
      <SmallCard />
    </>
  );
};

export default Contact;
